export default "__VITE_ASSET___g7HYNAv__"